/**
 * @generated SignedSource<<c130d07ae342a6de52004124d7f8333b>>
 * @relayHash 307b5926ac69d4681e09c8e5385ade53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ebf723434cc18c5aec339f88f3dac652f858c87b0d54d663dc0bd607b1a2f1b0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ebf723434cc18c5aec339f88f3dac652f858c87b0d54d663dc0bd607b1a2f1b0",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
